import AtomeLandingPage from './AtomeLandingPage'

export default AtomeLandingPage
